import { createComponent } from './component'
import newWidget from './field/index'
function Search(h, props, slots, ct, listeners) {
  let type = props.item.fieldType
  const newType = newWidget[type] || newWidget.disableText
  console.log(type);
  return (
    <div style='display:flex'>
      {slots.action ? slots.action() : slots.default()}
      <div style='flex:1;overflow:hidden'>
        <newType  {...{
          attrs: props
        }}
          {...{ on: listeners }}
        ></newType>
      </div>
    </div >
  );
}
export default createComponent('search')(Search);
